"use client";

import * as React from "react";

import { ChromeFooter } from "@/components/platform/ChromeFooter";
import { RadixSidebarDemo } from "@/components/Sidebar";
import {
  INORA_SCROLL_SHELL_CLASS,
  INORA_SCROLL_SURFACE_CLASS,
} from "@/lib/ui/scroll-surface";

type AppSidebarLayoutProps = {
  children: React.ReactNode;
  hideFooter?: boolean;
  lockMainScroll?: boolean;
};

/**
 * Same chrome as `/home`: workspace sidebar + scrollable main column.
 * Use for settings, billing, and any other authenticated full-width surfaces
 * that should stay navigable without losing the sidebar.
 *
 * Footer visibility follows `lib/platform/chrome-policy` (billing only).
 */
export function AppSidebarLayout({
  children,
  hideFooter,
  lockMainScroll = false,
}: AppSidebarLayoutProps) {
  return (
    <div
      className={`App ${INORA_SCROLL_SHELL_CLASS} w-full min-w-0 bg-[#010102]`}
    >
      <section className="relative flex h-full min-h-0 w-full min-w-0 flex-1 overflow-hidden bg-[#010102] p-2">
        <RadixSidebarDemo>
          <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
            <div
              className={
                lockMainScroll
                  ? "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
                  : `${INORA_SCROLL_SURFACE_CLASS} min-w-0`
              }
            >
              {children}
              {!hideFooter && <ChromeFooter />}
            </div>
          </div>
        </RadixSidebarDemo>
      </section>
    </div>
  );
}
